import React from 'react'
import { useTranslation } from 'react-i18next'
import { Fonts } from 'components/base-ui'
import ModalConfirm, { ModalConfirmProps } from 'components/base-ui/ModalConfirm'
import { ModalContent } from './styled'

const ModalConfirmCombineCoupon = (props: ModalConfirmProps) => {
  const { t } = useTranslation()
  return (
    <ModalConfirm shouldCloseOnOverlayClick={false} hideCloseButton={false} buttonWidth="90%" {...props}>
      <ModalContent>
        <Fonts.H3>{t('dineIn.modal.shareCoupon.title')}</Fonts.H3>
      </ModalContent>
    </ModalConfirm>
  )
}

export default ModalConfirmCombineCoupon
